import { render, staticRenderFns } from "./BulletinDeSalaireModalDisplay.vue?vue&type=template&id=22afec66"
import script from "./BulletinDeSalaireModalDisplay.vue?vue&type=script&lang=ts"
export * from "./BulletinDeSalaireModalDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports